module.exports = __webpack_public_path__ + "08_long_gray.ebef95c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_long_gray.png
// module id = mKQq
// module chunks = 0